import {AUTH_APP_URL, SUBSCRIBE_AUTH_STATE, AUTH_STATE_UPDATED} from './constants'

let jwt = null
export default () => jwt

const iframe = document.createElement('iframe')
iframe.setAttribute('src', AUTH_APP_URL)
iframe.style.visibility = 'hidden'
iframe.style.height = 0
iframe.onload = () => iframe.contentWindow.postMessage({type: SUBSCRIBE_AUTH_STATE}, AUTH_APP_URL)
document.body.appendChild(iframe)

window.addEventListener('message', e => {
  if (e.origin === AUTH_APP_URL && e.data.type === AUTH_STATE_UPDATED) jwt = e.data.jwt
})
